import Meaning from "./Meaning";
import "./Results.css"

export default function Results(props){
   
    if (props.result) {
      return (
        <div className="Results">
          <section>
            <h2>{props.result.word}</h2>
            <div className="phonetic">/{props.result.phonetic}/</div>
          </section>
          {props.result.meanings.map(function (meaning, index) {
            return (
              <section key={index}>
                <Meaning meaning={meaning} />
              </section>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
}